import Vue from 'vue';
import Router from 'vue-router';
import Admin from '@/views/Admin.vue';
import Chat from '@/views/Chat.vue';
import Phrases from '@/views/Phrases.vue';
import Login from '@/views/Login.vue';
import Profile from '@/views/Profile.vue';

const environment = process.env.VUE_APP_ENVIRONMENT || process.env.NODE_ENV;

Router.prototype.push = (() => {
  const originalPush = Router.prototype.push;

  return async function push(...args) {
    try {
      await originalPush.call(this, ...args);
    } catch (e) {
      if (e.name !== 'NavigationDuplicated') {
        throw e;
      }

      if (environment === 'development') {
        console.error(e);
      }
    }
  };
})();

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:queue(new|appointment|own|closed)/:chatId([^/]*)?/:details(pet|questionnaire)',
      name: 'chat',
      component: Chat,
      props: true,
    },
    {
      path: '/:queue(new|appointment|own|closed)/:chatId',
      redirect: '/:queue/:chatId/pet',
    },
    {
      path: '/:queue(new|appointment|own|closed)',
      redirect: '/:queue//pet',
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      children: [
        {
          path: '/admin/:profileId',    
        },
      ],
    },
    {
      path: '/phrases',
      name: 'phrases',
      component: Phrases,
    },
    {
      path: '*',
      redirect: '/new//pet',
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !localStorage.jwtToken) {
    next('/login');
  } else {
    next();
  }
});

export const createLinkToChat = (chat) => {
  const {
    queue,
    chatId,
    details = 'pet',
  } = chat;

  return {
    name: 'chat',
    params: {
      queue,
      chatId: chatId || '',
      details,
    },
  };
};

export default router;
